import React, {useState, useRef, useEffect} from 'react';
import './kontakt.css';

export default function Kontakt(){
  const [selectedPack, setSelectedPack] = useState('');
  const packs = ['Basic','Premium','VIP'];

  // custom select open state
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(()=>{
    function onDoc(e){
      if(wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('click', onDoc);
    return ()=>document.removeEventListener('click', onDoc);
  },[]);

  function sendMail(e){
    e.preventDefault();
    const f = new FormData(e.target);
    const name = f.get('name')?.trim();
    const email = f.get('email')?.trim();
    if(!name || !email){
      alert('Bitte Name und E‑Mail ausfüllen.');
      return;
    }

    const phone = f.get('phone') || '';
    const date = f.get('date') || '';
    const guests = f.get('guests') || '';
    const pack = selectedPack || '';
    const message = f.get('message') || '';

    const subject = `Catering-Anfrage: ${name}`;
    const bodyLines = [
      `Name: ${name}`,
      `E‑Mail: ${email}`,
      `Telefon: ${phone}`,
      `Wunschtermin: ${date}`,
      `Personenzahl: ${guests}`,
      `Paket: ${pack}`,
      '',
      `Nachricht:`,
      `${message}`
    ];

    const mailto = `mailto:info@libertystreetfood.de?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(bodyLines.join('\n'))}`;
    window.location.href = mailto;
  }

  return (
    <div className="kontakt-page">
      <div className="kontakt-inner">
        <div className="kontakt-info">
          <h2 className="title">Kontakt</h2>
          <p>Schreib uns die Eckdaten deines Events — dein Mailclient öffnet sich und du kannst die Anfrage direkt absenden.</p>

          <div className="contact-card">
            <strong>Liberty Street Food GmbH</strong>
            <div>info@libertystreetfood.de</div>
            <div>+49 15511522559</div>
            <div>Musterstraße 1, 12345 Musterstadt</div>
          </div>
        </div>

        <div className="kontakt-form-wrap">
          <form onSubmit={sendMail} className="kontakt-form">
            <div className="grid">
              <input name="name" placeholder="Name *" required />
              <input name="email" type="email" placeholder="E‑Mail *" required />
              <input name="phone" placeholder="Telefon" />
              <input name="date" type="date" />
              <input name="guests" type="number" placeholder="Personenzahl" />

              <div className="custom-select-wrap" ref={wrapRef}>
                <div className="custom-select" onClick={()=>setOpen(o=>!o)} role="button" tabIndex={0}>
                  <div className="value">{selectedPack || 'Wunschpaket (optional)'}</div>
                  <div className="caret">▾</div>
                </div>
                {open && (
                  <div className="options" role="listbox">
                    {packs.map((p)=> (
                      <div key={p} className="option" onClick={()=>{setSelectedPack(p); setOpen(false);}}>{p}</div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <textarea name="message" rows="6" placeholder="Erzähl uns kurz von deinem Event (Ort, Datum, gewünschte Uhrzeit, Besonderheiten)"></textarea>

            <div className="actions">
              <button type="submit" className="btn primary">Anfrage per E‑Mail erstellen</button>
              <button type="button" className="btn ghost" onClick={()=>{window.location.href='mailto:info@libertystreetfood.de'}}>Nur E‑Mail öffnen</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
